import * as XLSX from "xlsx";

const fit = (rows) => Object.keys(rows[0] || {}).map((k) => ({ wch: Math.min(48, Math.max(12, ...rows.map((r) => String(r[k] ?? "").length + 2), k.length + 2)) }));

const poSheet = (po, quote) => {
  const header = [
    ["Heliopolis Pharmaceuticals — Supplier Purchase Order"], [],
    ["PO number", po.po_number], ["Status", po.status], ["PO date", po.po_date || ""], ["Delivery date", po.delivery_date || ""],
    ["Quote", quote?.quote_number || po.quote_number || ""], ["Client", quote?.client_name || ""],
    ["Supplier", po.supplier_name || ""], ["Supplier contact", po.supplier_contact || ""], ["Supplier email", po.supplier_email || ""], ["Supplier address", po.supplier_address || ""],
    ["Notes", po.notes || ""], [],
  ];
  const lines = (po.lines || []).map((l, i) => ({ "#": i + 1, Item: l.name, Form: l.form || "", Strength: l.strength || "", Quantity: Number(l.quantity || 0) }));
  const total = lines.reduce((a, l) => a + l.Quantity, 0);
  const ws = XLSX.utils.aoa_to_sheet(header);
  XLSX.utils.sheet_add_json(ws, lines.length ? lines : [{ "#": "", Item: "No lines", Form: "", Strength: "", Quantity: "" }], { origin: -1 });
  XLSX.utils.sheet_add_aoa(ws, [[], ["", "Total units", "", "", total]], { origin: -1 });
  ws["!cols"] = [{ wch: 18 }, { wch: 44 }, { wch: 14 }, { wch: 14 }, { wch: 12 }];
  return ws;
};

const safe = (s) => String(s || "Sheet").replace(/[\\/?*[\]:]/g, "-").slice(0, 31);

export function exportPoExcel(po, quote) {
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, poSheet(po, quote), safe(po.po_number));
  XLSX.writeFile(wb, `${po.po_number}.xlsx`);
}

export function exportPosExcel(pos, quote) {
  const wb = XLSX.utils.book_new();
  const summary = pos.map((p) => ({ "PO number": p.po_number, Status: p.status, "PO date": p.po_date || "", "Delivery date": p.delivery_date || "", Supplier: p.supplier_name || "", Lines: (p.lines || []).length, "Total units": (p.lines || []).reduce((a, l) => a + Number(l.quantity || 0), 0) }));
  const ws = XLSX.utils.json_to_sheet(summary.length ? summary : [{ "PO number": "No supplier POs" }]);
  ws["!cols"] = fit(summary.length ? summary : [{ "PO number": "" }]);
  XLSX.utils.book_append_sheet(wb, ws, "Summary");
  const all = pos.flatMap((p) => (p.lines || []).map((l) => ({ "PO number": p.po_number, Supplier: p.supplier_name || "", Status: p.status, Item: l.name, Form: l.form || "", Strength: l.strength || "", Quantity: Number(l.quantity || 0) })));
  if (all.length) { const ws2 = XLSX.utils.json_to_sheet(all); ws2["!cols"] = fit(all); XLSX.utils.book_append_sheet(wb, ws2, "All lines"); }
  pos.forEach((p) => XLSX.utils.book_append_sheet(wb, poSheet(p, quote), safe(p.po_number)));
  XLSX.writeFile(wb, `${quote?.quote_number || "quote"}-supplier-POs.xlsx`);
}
